import React, { useState, useEffect } from 'react';
import { Instagram } from 'lucide-react';

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="landing-page">
      {/* HERO SECTION */}
      <section className={`hero-section ${isVisible ? 'fade-in' : ''}`}>
        <div className="hero-content">
          <div className="logo-small">TD•TB</div>
          <h1 className="hero-title">
            <span className="title-small">THE</span>
            <span className="title-large">DANCE</span>
            <span className="title-medium">
              <span className="decorative-line"></span>
              <span className="ampersand-text">& THE</span>
              <span className="decorative-line"></span>
            </span>
            <span className="title-large">BEAT</span>
            <span className="title-small concert-text">CONCERT</span>
          </h1>
          <p className="hero-subtitle">A Showcase Of Rhythm And Movement.</p>
        </div>
        {/* Provision for hero background image */}
        <div className="hero-image-placeholder" aria-hidden="true"></div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-section">
        <div className="gold-divider"></div>
        <div className="section-content">
          <h2 className="section-heading">A GLOBAL RHYTHM EXPERIENCE.</h2>
          <p className="section-text">
            The Dance & The Beat Concert is a premium multi-genre celebration of sound, 
            movement, and culture. Urban in energy. Elegant in execution.
          </p>
        </div>
        <div className="gold-divider"></div>
      </section>

      {/* EVENT DETAILS SECTION */}
      <section className="event-details-section">
        <div className="gold-divider"></div>
        <div className="section-content">
          <div className="event-details-grid">
            <div className="event-detail">
              <h4 className="detail-label">DATE</h4>
              <p className="detail-value">Coming Soon</p>
            </div>
            <div className="event-detail">
              <h4 className="detail-label">VENUE</h4>
              <p className="detail-value">Coming Soon</p>
            </div>
            <div className="event-detail">
              <h4 className="detail-label">CITY</h4>
              <p className="detail-value">Coming Soon</p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer-section">
        <div className="footer-content">
          <div className="footer-logo">TD•TB</div>
         <div className="social-icons">
  <a 
    href="https://www.instagram.com/idancealot/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="social-link"
    aria-label="Follow us on Instagram"
    style={{ 
      display: "flex", 
      alignItems: "center", 
      gap: "10px",
      textDecoration: "none"
    }}
  >
    <Instagram size={24} />
    <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.2" }}>
      <span style={{ fontWeight: 600 }}>@iDancealot</span>
      <span style={{ fontSize: "0.85rem", opacity: 0.7 }}>
        Follow us for more
      </span>
    </div>
  </a>
</div>
          <p className="footer-text">© 2026 An iDancealot production. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
